import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Voicemail } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const VoicemailNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected }) => {
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-pink-50 to-pink-100
        ${selected ? 'border-pink-500 shadow-lg' : 'border-pink-300 shadow'}
        min-w-[180px]
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-pink-500 !w-3 !h-3"
      />

      <div className="flex items-center gap-2 mb-2">
        <Voicemail className="h-5 w-5 text-pink-600" />
        <div className="flex-1">
          <div className="font-semibold text-pink-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-pink-700">{data.description}</div>
          )}
        </div>
        {!data.enabled && (
          <div className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded">
            Disabled
          </div>
        )}
      </div>

      {data.priority !== undefined && (
        <div className="text-xs text-pink-700 mt-1">
          Priority: {data.priority}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="!bg-pink-500 !w-3 !h-3"
      />
    </div>
  );
};

